import { render, staticRenderFns } from "./InvoiceTrailSendInvoice.vue?vue&type=template&id=a2478a38&"
import script from "./InvoiceTrailSendInvoice.vue?vue&type=script&lang=js&"
export * from "./InvoiceTrailSendInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports